import { useEffect, useRef, useState } from "react";
import Header from "../../components/header/Header";
import "./administrator.css";
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { hiddenMedalliaButton } from "../../components/hidemedallia";
import { useForm } from "react-hook-form";
import { FaX } from "react-icons/fa6";
import { saveAs } from "file-saver";
import Overlay from "react-bootstrap/Overlay";

function AdministratorCL() {
  const [turnData, setTurnData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const containerRef = useRef(null);
  const [statusModal, setStatusModal] = useState(false);
  const [alertDays, setAlertDays] = useState(false);
  const [loaderModal, setLoaderModal] = useState(false);
  const [showBtnShowMore, setBtnShowMore] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

    const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };



  const {
    register: registerForm2,
    handleSubmit: handleSubmitForm2,
    reset: resetForm2,
    formState: { errors: errorsForm2 },
  } = useForm({ mode: "onChange", shouldFocusError: true });

  const {
    register: register,
    handleSubmit: handleSubmitForm1,
    watch,
    reset: reset,
    setError,
    formState: { errors: errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      start: getCurrentDate(),
      end: getCurrentDate(),
    },
  });

  useEffect(() => {
    getTurns();
  }, []);


  useEffect(() => {
    const cleanMedallia = hiddenMedalliaButton();
    return cleanMedallia;
  }, []);

  const handleLoadMore = async () => {
    const nextPage = page + 1;
    setPage(nextPage);
    await getTurns(nextPage);
  };

  const getTurns = async () => {
    try {
      setShowLoader(true);
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/shipment?page=${page}&limit=10`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
        },
      });
      if (response.data.data.current_page === response.data.data.total_pages) {
        setBtnShowMore(false);
      } else {
        setBtnShowMore(true);
      }

      if (response.data.data.shipments.length > 0) {
        setShowLoader(false);
        setTurnData((prevData) => [
          ...prevData,
          ...response.data.data.shipments,
        ]);
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error",
        text: "Error al consultar, por favor intentalo de nuevo",
        icon: "error",
      });
    }
  };

  const getStatus = (id) => {
    switch (id) {
      case 1:
        return "Etiqueta emitida";
        break;
      case 2:
        return "Pesaje";
        break;
      case 3:
        return "Documentado";
        break;
      case 4:
        return "Finalizado";
        break;
      case 5:
        return "Cancelado en Pesador";
        break;
      case 6:
        return "Cancelado en Mostrador";
      default:
        return "";
        break;
    }
  };

  const cancelWeigher = async (id) => {
    const { value: description, isConfirmed } = await Swal.fire({
      title: "Para cancelar el turno, ingresa el motivo",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Cancelar turno",
      cancelButtonText: "No cancelar turno",
      showLoaderOnConfirm: true,
      preConfirm: (inputValue) => {
        if (!inputValue) {
          Swal.showValidationMessage("Debes ingresar un motivo");
          return false;
        }
        return inputValue;
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });

    if (isConfirmed && description) {
      try {
        const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard/cancel`;
        const body = {
          id: id,
          description: description,
          user_id: localStorage.getItem("light-load-email"),
        };
        const response = await axios.put(url, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          },
        });

        Swal.fire({
          icon: "success",
          title: "Turno cancelado exitosamente",
        }).then((result) => {
          window.location.reload();
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error al cancelar turno",
          text: error.response?.data?.message || "Ocurrió un error inesperado",
        });
      }
    }
  };

  const reactiveWeigher = async (id) => {
    const result = await Swal.fire({
      title: "Seguro que quieres reactivar este turno?",
      showCancelButton: true,
      confirmButtonText: "Reactivar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/guard/reactivate_turn/${id}`;
        const body = {
          user_id: localStorage.getItem("light-load-email"),
        };

        const response = await axios.put(url, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          },
        });

        window.location.reload();
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "No se pudo reactivar el turno", "error");
      }
    }
  };

  const getTypeShipments = (type) => {
    switch (type) {
      case 1:
        return "RX";
      case 2:
        return "ETD";
      case 3:
        return "Manual";
      default:
        return "";
    }
  };

  const getInspectionStatus = (type) => {
    switch (type) {
      case 0:
        return "Incorrecto";
      case 1:
        return "Correcto";
      default:
        return "";
    }
  };

  const getCancelText = (type) => {
    switch (type) {
      case 5:
        return "Pesador";
      case 6:
        return "Documentador";
      default:
        return "";
    }
  };

  const handleModalClick = (event) => {
    event.stopPropagation();
  };

  const formatDateWS = (dateString) => {
    setLoaderModal(true);
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleExportForm = async (data) => {
    const { startDate, endDate } = data;

    const start = new Date(startDate);
    const end = new Date(endDate);

    const diffInMs = end - start;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    try {
      if (diffInDays > 7) {
        setAlertDays(true);
        return;
      }
      setAlertDays(false);
      const formattedStart = formatDateWS(startDate);
      const formattedEnd = formatDateWS(endDate);

      const url = `${ process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/shipment?startDate=${formattedStart}&finishDate=${formattedEnd}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
        },
      });
      console.log("Response export:", response.data.data.shipments);

      const transformShipments = response.data.data.shipments.map((turn) => ({
        Turno: turn.turn_number || "-",
        Embarque: turn.tag_number || "-",
        Status: turn.status ? getStatus(turn.status) : "-",
        Piezas: turn.pieces || "-",
        Descripción: turn.merchandise_description || "-",
        Destino: turn.destination || "-",
        Usuario: turn.user_create || "-",
        "Fecha creación": turn.date_create || "-",
        "ID cantidad": turn.quantity_id || "-",
        "Usuario cantidad": turn.user_quantity || "-",
        "Fecha cantidad": turn.date_quantity || "-",
        Guía: turn.awb || "-",
        "Usuario Guía": turn.user_awb || "-",
        "Fecha Guía": turn.date_awb || "-",
        "Usuario Cancelado": turn.user_cancel || "-",
        "Fecha Cancelado": turn.date_cancel || "-",
        "Usuario Voceado": turn.user_scream || "-",
        "Fecha Voceado": turn.date_scream || "-",
        "Animal vivo": turn.avi ? "Sí" : "No",
        "Observaciones Inspector": turn.inspection_description || "-",
        "Usuario Observaciones Inspector": turn.user_description_isnp || "-",
        "Fecha Observaciones Inspector": turn.date_description_isnp || "-",
        "Tipo de inspección": getTypeShipments(turn.inspection_type) || "-",
        "Usuario tipo de inspección": turn.user_inspection_type || "-",
        "Fecha tipo de inspección": turn.date_inspection_type || "-",
        "Estatus Inspección":
          getInspectionStatus(turn.inspection_status) || "-",
        "Usuario Estatus inspección": turn.user_inspection_status || "-",
        "Fecha Estatus inspección": turn.date_inspection_status || "-",
        "Observaciones Pesador": turn.weighing_description || "-",
        "Dónde fue cancelado": getCancelText(turn.where_cancel) || "-",
        "Descripción cancelación": turn.cancel_description || "-",
        "Usuario asignado": turn.user_assign_turn || "-",
        "Fecha asignación": turn.date_assign_turn || "-",
        "Usuario que reasignó": turn.user_reassign_turn || "-",
        "Fecha de reasignar": turn.date_reassign_turn || "-",
        "Usuario que finalizó": turn.user_turn_finish || "-",
        "Fecha finalizada": turn.date_turn_finish || "-",
        "Usuario que recibió el turno": turn.user_transfer_turn || "-",
        "Fecha que recibió el turno": turn.date_transfer_turn || "-",
        "Usuario que reactivó": turn.user_reactivate || "-",
        "Fecha reactivación": turn.date_reactivate || "-",
      }));

      await generateExcelExport(
        transformShipments,
        formattedStart,
        formattedEnd
      );
      setLoaderModal(false);
      setStatusModal(false);
      resetForm2();
      setAlertDays(false);
    } catch (error) {
      console.log("Error al exportar los datos:", error);
      setLoaderModal(false);
      setStatusModal(false);
      resetForm2();
      setAlertDays(false);
      Swal.fire({
        title: "Error",
        text: "Error al exportar, intentelo de nuevo más tarde",
        icon: "error",
      });
    }
  };

  const renderExportModal = () => {
    return (
      <div className="inspector-modal" onClick={handleModalClick}>
        <div className="kpi-header-modal">
          <h4>Exportar</h4>
          <FaX
            style={{ color: "#dc0f38", cursor: "pointer" }}
            onClick={() => {
              setStatusModal(false);
              resetForm2();
              setAlertDays(false);
            }}
          />
        </div>

        {!loaderModal ? (
          <div className="inspector-body-modal">
            <form
              id="exportExcel"
              className="formRenderExport"
              onSubmit={handleSubmitForm2(handleExportForm)}
            >
              <div className="exportFormContent">
                <label>Fecha Inicio</label>
                <input
                  type="date"
                  {...registerForm2("startDate", {
                    required: "Este campo es obligatorio",
                    onChange: () => setAlertDays(false),
                  })}
                />
                {errorsForm2.startDate && (
                  <p className="errorExport">{errorsForm2.startDate.message}</p>
                )}
              </div>

              <div className="exportFormContent">
                <label>Fecha Final</label>
                <input
                  type="date"
                  {...registerForm2("endDate", {
                    required: "Este campo es obligatorio",
                    onChange: () => setAlertDays(false),
                  })}
                />
                {errorsForm2.endDate && (
                  <p className="errorExport">{errorsForm2.endDate.message}</p>
                )}
              </div>

              <button type="submit" form="exportExcel">
                Exportar
              </button>
            </form>

            {alertDays && (
              <div className="alertdays">
                <p>El rango de fecha tiene que ser menor a 7 días</p>
              </div>
            )}
          </div>
        ) : (
          <div className="modal-container">
            <span class="loader-inspector"></span>
          </div>
        )}
      </div>
    );
  };

  const generateExcelExport = async (data, startDate, endDate) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Inspector");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, `inspector-${startDate}-${endDate}.xlsx`);
  };

   //filtro
  const turnRef = useRef(null);
  const awbRef = useRef(null);
  const startRef = useRef(null);
  const endRef = useRef(null);

  const turn = watch("turn");
  const awb = watch("awb");
  const start = watch("start");
  const end = watch("end");

  const [inputDisabled, setInputDisabled] = useState({
    turn: false,
    awb: false,
  });
  const [showOverlay, setShowOverlay] = useState({
    turn: false,
    awb: false,
    start: false,
    end: false,
  });
  const [formValues, setFormValues] = useState({
    start: "",
    end: "",
    turn: "",
    awb: "",
  });


  function formatDateIso(dateISO) {
    const [year, month, day] = dateISO.split("-");
    return `${day}/${month}/${year}`;
  }

  const onSubmit = async (data) => {
    if (new Date(data.start) > new Date(data.end)) {
      setError("start", {
        type: "manual",
        message: "La fecha de inicio no puede ser mayor que la de fin",
      });
      return;
    }

    const dateStart = formatDateIso(data.start);
    const dateEnd = formatDateIso(data.end);

    try {
      let url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/shipment?startDate=${dateStart}&finishDate=${dateEnd}`;

      if (inputDisabled.turn && data.awb) {
        url += `&awb=${data.awb}`;
      }

      if (inputDisabled.awb && data.turn) {
        url += `&turn=${data.turn}`;
      }

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
        },
      });

      if (res.data.code === 1) {
        setTurnData(res.data.shipments || []);
      }
    } catch (error) {
      console.log("Error al filtrar los datos:", error);
      console.error(error);
    }
  };

   const clearFilters = async () => {
    reset({
      start: getCurrentDate(),
      end: getCurrentDate(),
      turn: "",
      awb: "",
    });
    setPage(1);
    setTurnData([]);
    setInputDisabled({ turn: false, awb: false });
    await getTurns();
  };

  useEffect(() => {
    if (turn && turn.trim() !== "") {
      setInputDisabled((prev) => ({ ...prev, awb: true }));
    } else {
      setInputDisabled((prev) => ({ ...prev, awb: false }));
    }

    if (awb && awb.trim() !== "") {
      setInputDisabled((prev) => ({ ...prev, turn: true }));
    } else {
      setInputDisabled((prev) => ({ ...prev, turn: false }));
    }
  }, [turn, awb]);

  useEffect(() => {
    const subscription = watch((value) => {
      setFormValues({
        start: value.start || "",
        end: value.end || "",
        turn: value.turn || "",
        awb: value.awb || "",
      });
    });
    return () => subscription.unsubscribe();
  }, [watch]);


  return (
    <>
      <div className="body-administrator">
        <Header />

        <h4>Administrador carga ligera</h4>

        <div className="table-container">
          <div className="actions-container">
            <form onSubmit={handleSubmitForm1(onSubmit)}>
              <div className="inputs-con">
                <div className="input-ind">
                  <div className="form-floating mb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.turn ? "is-invalid" : ""
                      }`}
                      id="turn"
                      name="turn"
                      placeholder="Turno"
                      {...register("turn", {
                        pattern: {
                          value: /^[0-9]+$/,
                          message: "Solo se permiten números",
                        },
                      })}
                      ref={(e) => {
                        register("turn").ref(e);
                        turnRef.current = e;
                      }}
                      onFocus={() =>
                        setShowOverlay((prev) => ({ ...prev, turn: true }))
                      }
                      onBlur={() =>
                        setShowOverlay((prev) => ({ ...prev, turn: false }))
                      }
                    />
                    <label htmlFor="turn">Turno</label>
                    <Overlay
                      target={turnRef.current}
                      show={!!errors.turn && showOverlay.turn}
                      placement="top"
                    >
                      {(props) => (
                        <div
                          {...props}
                          style={{
                            backgroundColor: "rgba(255, 0, 0, 0.85)",
                            padding: "5px 10px",
                            color: "white",
                            borderRadius: 4,
                            fontSize: 12,
                            zIndex: 9999,
                            marginBottom: "10px",
                            ...props.style,
                          }}
                        >
                          {errors.turn?.message}
                        </div>
                      )}
                    </Overlay>
                  </div>
                </div>
                <div className="input-ind">
                  <div className="form-floating mb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.awb ? "is-invalid" : ""
                      }`}
                      id="awb"
                      name="awb"
                      placeholder="Guía"
                      {...register("awb", {
                        pattern: {
                          value: /^\d{3}-\d{8}$/,
                          message: "Formato No. Guía invalido",
                        },
                      })}
                      ref={(e) => {
                        register("awb").ref(e);
                        awbRef.current = e;
                      }}
                      onFocus={() =>
                        setShowOverlay((prev) => ({ ...prev, awb: true }))
                      }
                      onBlur={() =>
                        setShowOverlay((prev) => ({ ...prev, awb: false }))
                      }
                    />
                    <label htmlFor="awb">Guía</label>
                    <Overlay
                      target={awbRef.current}
                      show={!!errors.awb && showOverlay.awb}
                      placement="top"
                    >
                      {(props) => (
                        <div
                          {...props}
                          style={{
                            backgroundColor: "rgba(255, 0, 0, 0.85)",
                            padding: "5px 10px",
                            color: "white",
                            borderRadius: 4,
                            fontSize: 12,
                            zIndex: 9999,
                            marginBottom: "10px",
                            ...props.style,
                          }}
                        >
                          {errors.awb?.message}
                        </div>
                      )}
                    </Overlay>
                  </div>
                </div>
                <div className="input-ind">
                  <div className="form-floating mb-3">
                    <input
                      type="date"
                      className={`form-control ${
                        errors.start ? "is-invalid" : ""
                      }`}
                      id="start"
                      name="start"
                      placeholder="Fecha inicio"
                      {...register("start", {
                        required: turn  ? "Selecciona una fecha de inicio" : false,
                        validate: (value) => {
                          if (!turn) return true;

                          if (start && end && new Date(value) > new Date(end)) {
                            return "La fecha de inicio no puede ser mayor que la de fin";
                          }
                          return true;
                        },
                      })}
                      ref={(e) => {
                        register("start").ref(e);
                        startRef.current = e;
                      }}
                      onFocus={() =>
                        setShowOverlay((prev) => ({ ...prev, start: true }))
                      }
                      onBlur={() =>
                        setShowOverlay((prev) => ({ ...prev, start: false }))
                      }
                    />
                    <label htmlFor="start">Fecha inicio</label>
                    <Overlay
                      target={startRef.current}
                      show={!!errors.start && showOverlay.start}
                      placement="top"
                    >
                      {(props) => (
                        <div
                          {...props}
                          style={{
                            backgroundColor: "rgba(255, 0, 0, 0.85)",
                            padding: "5px 10px",
                            color: "white",
                            borderRadius: 4,
                            fontSize: 12,
                            zIndex: 9999,
                            marginBottom: "10px",
                            ...props.style,
                          }}
                        >
                          {errors.start?.message}
                        </div>
                      )}
                    </Overlay>
                  </div>
                </div>
                <div className="input-ind">
                  <div className="form-floating mb-3">
                    <input
                      type="date"
                      className={`form-control ${
                        errors.end ? "is-invalid" : ""
                      }`}
                      id="end"
                      name="end"
                      placeholder="Fecha fin"
                      {...register("end", {
                        required: turn ? "Selecciona una fecha de fin" : false,
                        validate: (value) => {
                          if (!turn) return true;
                        }
                      })}
                      ref={(e) => {
                        register("end").ref(e);
                        endRef.current = e;
                      }}
                      onFocus={() =>
                        setShowOverlay((prev) => ({ ...prev, end: true }))
                      }
                      onBlur={() =>
                        setShowOverlay((prev) => ({ ...prev, end: false }))
                      }
                    />
                    <label htmlFor="floatingInput">Fecha fin</label>
                    <Overlay
                      target={endRef.current}
                      show={!!errors.end && showOverlay.end}
                      placement="top"
                    >
                      {(props) => (
                        <div
                          {...props}
                          style={{
                            backgroundColor: "rgba(255, 0, 0, 0.85)",
                            padding: "5px 10px",
                            color: "white",
                            borderRadius: 4,
                            fontSize: 12,
                            zIndex: 9999,
                            marginBottom: "10px",
                            ...props.style,
                          }}
                        >
                          {errors.end?.message}
                        </div>
                      )}
                    </Overlay>
                  </div>
                </div>
              </div>
              <div className="buttons-con">
                <button
                  type="submit"
                  className="btn_filter"
                  id="btn_filter"
                  
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  className="dlt_filter"
                  id="dlt_filter"
                  onClick={clearFilters}
                >
                  Borrar filtros
                </button>
                <button
                  type="button"
                  className="export_btn"
                  onClick={() => setStatusModal(true)}
                >
                  Exportar
                </button>
              </div>
            </form>
          </div>
          





          <div className="content-table-admin">
            <table className="sticky-table-ll-admin">
              <thead>
                <tr>
                  <th># Turno</th>
                  <th># Embarque</th>
                  <th>Status</th>
                  <th>Piezas</th>
                  <th>Descripción</th>
                  <th>Destino</th>
                  <th>usuario</th>
                  <th>Fecha creacion</th>
                  <th>id cantidad</th>
                  <th>user_quantity</th>
                  <th>date_quantity</th>
                  <th># Guía</th>
                  <th>usuario Guía</th>
                  <th>Fecha Guía</th>
                  <th>usuario Cancelado</th>
                  <th>Fecha Cancelado</th>
                  <th>usuario Voceado</th>
                  <th>Fecha Voceado</th>
                  <th>Animal vivo?</th>
                  <th>Observaciones Inspector</th>
                  <th>User Observaciones Inspector</th>
                  <th>Fecha Observaciones Inspector</th>
                  <th>Tipo de inspección</th>
                  <th>User tipo de inspección</th>
                  <th>Fecha tipo de inspección</th>
                  <th>Estatus Inspección</th>
                  <th>Usuario Estatus inspector</th>
                  <th>Fecha Estatus inspector</th>
                  <th>Observaciones Pesador</th>
                  <th>Donde fue cancelado</th>
                  <th>Descripción de la cancelación</th>
                  <th>Usuario asignado</th>
                  <th>Fecha de asignación</th>
                  <th>Usuario que reasignó</th>
                  <th>Fecha de reasignar</th>
                  <th>Usuario receptor del turno</th>
                  <th>Fecha que recibió turno</th>
                  <th>Usuario que finalizó</th>
                  <th>Fecha finalizada</th>
                  <th>User reactive</th>
                  <th>Fecha reactive</th>
                  <th>Pesador</th>
                </tr>
              </thead>

              <tbody ref={containerRef}>
                {turnData.map((turn, index) => (
                  <tr key={index}>
                    <td style={{ minWidth: "100px" }}>{turn.turn_number}</td>
                    <td style={{ minWidth: "130px" }}>{turn.tag_number}</td>
                    <td style={{ minWidth: "150px" }}>
                      {turn.status ? getStatus(turn.status) : ""}
                    </td>
                    <td style={{ minWidth: "100px" }}>{turn.pieces}</td>
                    <td style={{ minWidth: "150px" }}>
                      {turn.merchandise_description}
                    </td>
                    <td style={{ minWidth: "100px" }}>{turn.destination}</td>
                    <td style={{ minWidth: "150px" }}>{turn.user_create}</td>
                    <td style={{ minWidth: "180px" }}>{turn.date_create}</td>
                    <td
                      style={{
                        minWidth: "150px",
                        textAlign: turn.quantity_id ? "" : "center",
                      }}
                    >
                      {turn.quantity_id ? turn.quantity_id : "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "150px",
                        textAlign: turn.user_quantity ? "" : "center",
                      }}
                    >
                      {turn.user_quantity ? turn.user_quantity : "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "180px",
                        textAlign: turn.date_quantity ? "" : "center",
                      }}
                    >
                      {turn.date_quantity ? turn.date_quantity : "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "150px",
                        textAlign: turn.awb ? "" : "center",
                      }}
                    >
                      {turn.awb ? turn.awb : "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "150px",
                        textAlign: turn.user_awb ? "" : "center",
                      }}
                    >
                      {turn.user_awb ? turn.user_awb : "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.date_awb ? "" : "center",
                      }}
                    >
                      {turn.date_awb ? turn.date_awb : "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "150px",
                        textAlign: turn.user_cancel ? "" : "center",
                      }}
                    >
                      {turn.user_cancel ? turn.user_cancel : "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.date_cancel ? "" : "center",
                      }}
                    >
                      {turn.date_cancel ? turn.date_cancel : "-----"}
                    </td>

                    <td
                      style={{
                        minWidth: "150px",
                        textAlign: turn.user_scream ? "" : "center",
                      }}
                    >
                      {turn.user_scream ? turn.user_scream : "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.date_scream ? "" : "center",
                      }}
                    >
                      {turn.date_scream ? turn.date_scream : "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.avi ? "" : "center",
                      }}
                    >
                      {turn.avi ? "Sí" : "No"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.inspection_description ? "" : "center",
                      }}
                    >
                      {turn.inspection_description || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.user_description_isnp ? "" : "center",
                      }}
                    >
                      {turn.user_description_isnp || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.date_description_isnp ? "" : "center",
                      }}
                    >
                      {turn.date_description_isnp || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.inspection_type ? "" : "center",
                      }}
                    >
                      {getTypeShipments(turn.inspection_type) || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.user_inspection_type ? "" : "center",
                      }}
                    >
                      {turn.user_inspection_type || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.date_inspection_type ? "" : "center",
                      }}
                    >
                      {turn.date_inspection_type || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.inspection_status ? "" : "center",
                      }}
                    >
                      {getInspectionStatus(turn.inspection_status) || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.user_inspection_status ? "" : "center",
                      }}
                    >
                      {turn.user_inspection_status || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.date_inspection_status ? "" : "center",
                      }}
                    >
                      {turn.date_inspection_status || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.weighing_description ? "" : "center",
                      }}
                    >
                      {turn.weighing_description || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.where_cancel ? "" : "center",
                      }}
                    >
                      {getCancelText(turn.where_cancel) || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.cancel_description ? "" : "center",
                      }}
                    >
                      {turn.cancel_description || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.user_assign_turn ? "" : "center",
                      }}
                    >
                      {turn.user_assign_turn || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.date_assign_turn ? "" : "center",
                      }}
                    >
                      {turn.date_assign_turn || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.user_reassign_turn ? "" : "center",
                      }}
                    >
                      {turn.user_reassign_turn || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.date_reassign_turn ? "" : "center",
                      }}
                    >
                      {turn.date_reassign_turn || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.user_transfer_turn ? "" : "center",
                      }}
                    >
                      {turn.user_transfer_turn || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.date_transfer_turn ? "" : "center",
                      }}
                    >
                      {turn.date_transfer_turn || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.date_transfer_turn ? "" : "center",
                      }}
                    >
                      {turn.user_turn_finish || "----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.date_transfer_turn ? "" : "center",
                      }}
                    >
                      {turn.date_turn_finish || "----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.user_reactivate ? "" : "center",
                      }}
                    >
                      {turn.user_reactivate || "-----"}
                    </td>
                    <td
                      style={{
                        minWidth: "200px",
                        textAlign: turn.date_reactivate ? "" : "center",
                      }}
                    >
                      {turn.date_reactivate || "-----"}
                    </td>

                    <td>
                      <div className="admin-td">
                        {turn.status === 5 || turn.status === 6 ? (
                          <button
                            className="reactive-btn-wc"
                            onClick={() => reactiveWeigher(turn.id)}
                          >
                            Reactivar
                          </button>
                        ) : (
                          <button
                            className="cancel-btn-wc"
                            onClick={() => cancelWeigher(turn.id)}
                          >
                            Cancelar
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              {showBtnShowMore && !showLoader && (
                <button className="btn-load" onClick={handleLoadMore}>
                  Mostrar más
                </button>
              )}
              {showLoader && (
                <div className="load-t-c">
                  <div className="loader-table"></div>
                </div>
              )}
            </table>
          </div>

        </div>
      </div>

      <div
          className={`kpi-modal-bg ${statusModal ? "active" : ""}`}
          onClick={() => {
            setStatusModal(false);
            resetForm2();
            setAlertDays(false);
          }}
        >
          {statusModal && renderExportModal()}
      </div>
    </>
  );
}

export default AdministratorCL;
